import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comefunziona',
  templateUrl: './comefunziona.component.html',
  styleUrls: ['./comefunziona.component.scss']
})
export class ComefunzionaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/comefunziona/comefunziona.component.ts